import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { injectIntl, intlShape, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { Row, Col, Card, CardBody, Input, Button, Alert } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import config from '../../../../config';

import { removeItem } from '../../CartActions';
import { getProduct, getProductMatchingPack, getProductSlugPath } from '../../../Product/ProductActions';
import { getTranslation } from '../../../Intl/IntlActions';

import FileLoader from '../../../../components/Content/FileLoader';
import CartItemQuantitySelector from '../form/CartItemQuantitySelector';


class CartItem extends Component {
    handleRemoveItem = event => {
        event && event.preventDefault();
        this.props.dispatch(removeItem(this.props.item));
    }

    render() {
        const { product, item, locale } = this.props;
        if(item && product) {
            const matchingPack = getProductMatchingPack(product, item.quantity);
            return (
                <Fragment>
                    <Row key={product._id}>
                        <Col xs="2" md="4" className="text-center">
                            {product.pictures && product.pictures[0] && <FileLoader filename={product.pictures[0]} hidePlaceholders role="presentation" style={{ maxWidth: '60px', width: '100%' }} />}
                        </Col>
                        <Col>
                            <div className="text-dark alt-font">
                                <strong className="">{config.application.name}<sup>&reg;</sup></strong><br />
                                {getTranslation(product, 'name', locale)}<br />
                                <strong><FormattedMessage id="productUnitCountLabel" defaultMessage="{count} bottle(s)" values={{ count: item.quantity }} /></strong>
                                {matchingPack && matchingPack.freeCount ? <span className="text-warning">{' '}<FormattedMessage id="productPackFreeCount" defaultMessage="+{count} free bottle(s)" values={{ count: matchingPack.freeCount }} /></span> : null}
                            </div>

                            {!this.props.disableEdit && <div className="mt-2"><CartItemQuantitySelector product={product} onCart locale={this.props.locale} /></div>}
                        </Col>
                        {!this.props.disableEdit && (
                            <Col xs="1" className="text-right">
                                <a href="#" onClick={this.handleRemoveItem}><FontAwesome name="trash-alt" /></a>
                            </Col>
                        )}
                    </Row>
                    {
                        !this.props.disableEdit && (!matchingPack || !matchingPack.freeCount) && (
                            <div className="position-relative d-flex justify-content-between p-3 bg-secondary text-dark">
                                <span className="position-absolute text-secondary" style={{ top: '-1.2em', left: '44%' }}><FontAwesome name="caret-up" size="2x" /></span>
                                <strong className="special-font"><FormattedMessage id="cartItemProductPackPriceAlertTitle" defaultMessage="Decreasing prices" /></strong>
                                <span>
                                    <FormattedMessage id="cartItemProductPackPriceAlertText" defaultMessage="Increase the number of bottles to benefit from lower pricing" /><br />
                                    {/* <Link to={getProductSlugPath(product, this.props.intl.locale)} className="text-uppercase text-underline"><FormattedMessage id="learnMore" defaultMessage="Learn more" /></Link> */}
                                </span>
                            </div>
                        )
                    }
                </Fragment>
            );
        }
        return null;
    }
}

function mapStateToProps(store, props) {
    return {
        product: getProduct(store, props.item && props.item.productId),
    };
}

CartItem.defaultProps = {
    product: null,
    item: null,
    disableEdit: false,
    locale: '',
};

CartItem.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    product: PropTypes.object,
    item: PropTypes.object,
    locale: PropTypes.string,
    disableEdit: PropTypes.bool,
};


export default connect(mapStateToProps)(injectIntl(CartItem));
